import { ElementId } from '~/features/shared/ad/types'

export const spCoordinateDetailAds = {
  top: 'gAdbanner_1',
  middle: 'gAdbannerMobile',
  footer: 'gAdftrRectangle',
} as const satisfies Record<string, ElementId>

export const pcCoordinateDetailAds = {
  mainBottom: 'gAdcordedetail_1',
  sub: 'gAdcordedetail_2',
} as const satisfies Record<string, ElementId>
